module.exports = __webpack_public_path__ + "img/Gefahr_durch_Radioaktivität.ca3bf0da.svg";